export default {
  name: 'phone-country-select',
  data() {
    return {
      selectedCode: null,
      defaultValue: null,
      codeToCountries: [],
    }
  },
  methods: {
    handleSelectChange(event) {
      // Determine `selectedIndex` and use `defaultValue` if no selected index is found
      const selectedIndex = event.target.selectedIndex || Array.from(event.target.options)
        .findIndex(
          (option) => option.value === this.defaultValue
        )

      const selectedOption = event.target.options[selectedIndex]

      // Retrieve the code from data-code and display only it in the selected option
      this.selectedCode = selectedOption.getAttribute('data-code')
      selectedOption.textContent = this.selectedCode
    },
    initializeCountryCodes(selectElement) {
      const codeToCountries = {}
      // Iterate through all options, storing countries for each country code
      Array.from(selectElement.options)
        .forEach((option) => {
          const code = option.getAttribute('data-code')
          const country = option.getAttribute('data-country')

          if (!code || !country) return

          if (!codeToCountries[code]) {
            codeToCountries[code] = []
          }
          if (!codeToCountries[code].includes(country)) {
            codeToCountries[code].push(country)
          }
        })

      this.codeToCountries = codeToCountries
    },
    handleSelectOpen(event) {
      let newText
      // Update each option's text based on the list of countries with the same country code
      Array.from(event.target.options)
        .forEach((option) => {
          const code = option.getAttribute('data-code')
          const country = option.getAttribute('data-country')
          const countries = this.codeToCountries[code]

          if (!code || !country) return

          if (countries && countries.length > 1) {
            const reorderedCountries = [country, ...countries.filter((c) => c !== country)]
            newText = `${reorderedCountries.join(' / ')} (${code})`
          } else {
            newText = `${country} (${code})`
          }

          if (option.textContent !== newText) {
            option.textContent = newText
          }
        })
    }
  },
  mounted() {
    const selectElement = this.$el
    this.defaultValue = selectElement.getAttribute('data-default-value')

    if (this.defaultValue) {
      selectElement.dispatchEvent(new Event('change', { bubbles: true }))
    }
    this.initializeCountryCodes(selectElement)

    selectElement.addEventListener('focus', this.handleSelectOpen)
    selectElement.addEventListener('mousedown', this.handleSelectOpen)
    selectElement.addEventListener('blur', this.handleSelectChange)
  },
  beforeDestroy() {
    const selectElement = this.$el
    selectElement.removeEventListener('focus', this.handleSelectOpen)
    selectElement.removeEventListener('mousedown', this.handleSelectOpen)
    selectElement.removeEventListener('blur', this.handleSelectChange)
  },
  render() {
    return this.$scopedSlots.default({
      handleSelectChange: this.handleSelectChange,
      selectedCode: this.selectedCode
    })
  }
}
